import { queryClient } from "@istari-frontend/api-client";

import { resourceQueryOptions } from "~/resource/data-source/api/resource-query-options";
import { type ContentReadPurpose, readBufferedContent } from "~/resource/data-source/content/read-buffered-content";

// A selected revision must never fall back to the resource's current content.
export async function readResourceRevisionContent(
  resourceId: string,
  revisionId: string,
  purpose: ContentReadPurpose,
  signal?: AbortSignal,
) {
  const revision = await resolveResourceRevisionMetadata(resourceId, revisionId, signal);
  const content = await readBufferedContent(revision, purpose, signal);
  return { content, revision, resourceId };
}

export async function resolveResourceRevisionMetadata(resourceId: string, revisionId: string, signal?: AbortSignal) {
  signal?.throwIfAborted();
  const revision = await queryClient.ensureQueryData(resourceQueryOptions.revision(resourceId, revisionId));
  signal?.throwIfAborted();
  if (revision.fileRevisionId !== revisionId) {
    throw new Error("Requested revision metadata does not match the selected revision");
  }
  return revision;
}
